import { render, staticRenderFns } from "./AccessV1.vue?vue&type=template&id=5eb0c63a&scoped=true"
import script from "./AccessV1.vue?vue&type=script&lang=js"
export * from "./AccessV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb0c63a",
  null
  
)

export default component.exports